/**
 * Typ akce konfigurace mapy.
 *
 * @ignore
 */
enum ConfigActionType {
    /**
     * Nastavení téma konfigurace.
     */
    SET_TOPIC = 'mapio.setTopic',

    /**
     * Nastavení podkladové vrstvy.
     */
    SET_BACKGROUND_LAYER = 'mapio.setBackgroundLayer',

    /**
     * Nastavení popisné vrstvy.
     */
    SET_FOREGROUND_LAYER = 'mapio.setForegroundLayer',

    /**
     * Nastavení viditelných datových vrstev.
     */
    SET_LAYERS = 'mapio.setLayers',

    /**
     * Nastavení rozbalených uzlů katalogu.
     */
    SET_CATALOG_NODES = 'mapio.setCatalogNodes',

    /**
     * Nastavení pozice středu mapy.
     */
    SET_LOCATION = 'mapio.setLocation',

    /**
     * Nastavení přiblížení mapy.
     */
    SET_ZOOM = 'mapio.setZoom',

    /**
     * Nastavení filtru features z datových vrstev.
     */
    SET_FILTER = 'mapio.setFilter',
}

export default ConfigActionType;
